import { AAGUID, Currency } from '@interticket/core';
import { IPriceCategory } from '@core/interfaces/product/pricing-category.interface';

export class PriceCategory implements IPriceCategory {

  readonly id: AAGUID;
  readonly name: string;
  readonly currency: Currency;
  readonly price: number;
  readonly maxCapacity: number;
  readonly availableCapacity: number;
  readonly group: string;
  readonly amount: number;

  constructor(iPriceCategory: IPriceCategory) {
    this.id = iPriceCategory.id;
    this.name = iPriceCategory.name;
    this.currency = iPriceCategory.currency;
    this.price = iPriceCategory.price;
    this.maxCapacity = iPriceCategory.maxCapacity;
    this.availableCapacity = iPriceCategory.availableCapacity;
    this.group = iPriceCategory.group;
    this.amount = iPriceCategory.amount || 0;
  }

}
